import React from 'react';
import SharedCardType from '@src/pages/ticketShared/cardOrders/cardInformation/CardType';
import CardDigital from '@src/assets/icons/img-dijital-market.webp';
import img_fiziksel_kart2 from '@src/assets/icons/img_fiziksel_kart_market.webp';
import { VouIdCode } from '@src/store/enums';

const Wrapper = (props) => (
  <SharedCardType
    vouId={VouIdCode.Market}
    CardDigitalSrc={CardDigital}
    fizikselImgSrc={img_fiziksel_kart2}
    bankCardLogoClass1={{ className: 'bank-card-logo-market1', src: undefined }}
    bankCardLogoClass2={'bank-card-logo-market'}
    {...props}
  />
);

export default Wrapper;
